import React from 'react'
import AboutNavBar from '../components/AboutNavBar'
import Pricing from '../components/Pricing'
import Footer from '../components/Footer'
import RenderLinks from '../components/RenderLinks'

function Service() {
  return (
    <div>
      {/* <RenderLinks/> */}
      <AboutNavBar/>
      <Pricing/>
      <Footer/>
    </div>
  )
}

export default Service
